import { GridFilterOperator } from '@mui/x-data-grid-pro';

import FilterInput from '../components/FilterInput/FilterInput';

const customFilterOperators: GridFilterOperator[] = [
  {
    value: 'ilike',
    label: 'Contains',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: 'not,ilike',
    label: 'Does Not Contain',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: 'like',
    label: 'Contains (Case-Sensitive)',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: 'not,like',
    label: 'Does Not Contain (Case-Sensitive)',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: 'in',
    label: 'In',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: 'not,in',
    label: 'Not In',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: 'not',
    label: 'Not',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: 'is',
    label: 'Is',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: 'is,not',
    label: 'Is Not',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: '=',
    label: 'Equals',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: '!=',
    label: 'Not equals',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: '>',
    label: 'Greater than',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: '<',
    label: 'Less than',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: '>=',
    label: 'Greater than or equals',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
  {
    value: '<=',
    label: 'Less than or equals',
    getApplyFilterFn: () => null,
    InputComponent: FilterInput,
  },
];

export default customFilterOperators;
